import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Divider, Grid } from '@material-ui/core';
import moment from 'moment';
import CircularProgress from '@material-ui/core/CircularProgress';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import { deleteThisTimeSlot } from '../redux/timeSlotsActions';

function TimeSlotsList(props) {
  const myTimeSlots = useSelector(
    (state) => state.timeSlotsReducer.myTimeSlots
  );
  const loading = useSelector((state) => state.timeSlotsReducer.loading);
  const dispatch = useDispatch();

  const deleteTimeSlot = (_id) => {
    dispatch(deleteThisTimeSlot(_id));
  };

  return (
    <div>
      {!loading ? (
        <div style={{ marginTop: 50 }}>
          {Object.keys(myTimeSlots).length === 0 && (
            <div style={{ textAlign: 'center', color: 'red', marginTop: 50 }}>
              No TimeSlots Available
            </div>
          )}
          {Object.keys(myTimeSlots)
            .sort((a, b) => {
              return new Date(a) - new Date(b);
            })
            .map((key, index) => (
              <React.Fragment key={`one-doctor-${index}`}>
                {index !== 0 && (
                  <Divider
                    variant="middle"
                    style={{
                      margin: '15px auto',
                      width: '50%',
                    }}
                  />
                )}
                <Grid container spacing={2} justifyContent="center">
                  <Grid
                    xs={3}
                    item
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <div>
                      <div style={{ textAlign: 'center', fontWeight: 500 }}>
                        <div>{moment(key).format('Do')}</div>
                        <div style={{ fontSize: 22 }}>
                          {moment(key).format('MMM')}
                        </div>
                        <div>{moment(key).format('YYYY')}</div>
                      </div>
                    </div>
                  </Grid>
                  <Grid item style={{ display: 'flex', alignItems: 'center' }}>
                    <div>
                      {myTimeSlots[key].map((timeSlot, index2) => (
                        <div
                          key={`one-doc-timeslots-${timeSlot.startTime}-${timeSlot.endTime}-${index2}-${index}`}
                          style={{
                            marginTop: index2 !== 0 ? 12 : 0,
                            display: 'flex',
                            alignItems: 'center',
                          }}
                        >
                          <div
                            style={{
                              width: 160,
                              textDecoration: !timeSlot.availability
                                ? 'line-through'
                                : '',
                            }}
                          >
                            {moment(timeSlot.startTime).format('h:mm a')} -{' '}
                            {moment(timeSlot.endTime).format('h:mm a')}
                          </div>
                          <div style={{ marginLeft: 30 }}>
                            <IconButton
                              onClick={() =>
                                deleteTimeSlot(timeSlot.timeslotId)
                              }
                              style={{ padding: 8 }}
                            >
                              <DeleteIcon style={{ color: '#fa4839' }} />
                            </IconButton>
                          </div>
                        </div>
                      ))}
                    </div>
                  </Grid>
                </Grid>
              </React.Fragment>
            ))}
        </div>
      ) : (
        <div style={{ textAlign: 'center', marginTop: 100 }}>
          <CircularProgress style={{ color: 'red' }} />
        </div>
      )}
    </div>
  );
}

export default TimeSlotsList;
